import { render, staticRenderFns } from "./productEditWhitepaper.vue?vue&type=template&id=1e463ca0&scoped=true&"
import script from "./productEditWhitepaper.vue?vue&type=script&lang=js&"
export * from "./productEditWhitepaper.vue?vue&type=script&lang=js&"
import style0 from "./productEditWhitepaper.vue?vue&type=style&index=0&id=1e463ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e463ca0",
  null
  
)

export default component.exports